import jQuery from 'jquery';
import _ from 'underscore';

/**
 * @classdesc The filter by bounding box
 * @memberof core.filters
 */
class BoundingBoxFilter {
  /** 
   * Creates a new BoundingBoxFilter instance
   * @param {core.widget.Widget} widget - The widget the filter is added to.
   */
  constructor(widget) {
    this.widget = widget;
    this.cleanMarkers = true; //used to know in APILayer that we need to clean the markers in every 'idle'
  }
  /**
   * Filter the features by bounding box
   * @function
   * @memberOf BoundingBoxFilter
   * @param {Feature[]} features - The features to filter
   * @returns {Promise}
   */
  filterFeatures(features) {
    let deferred = jQuery.Deferred();
    let featuresInBoundingBox = [];
    _.each(features, (feature) => {
      let coordinate = {
        lat: feature.geometry.coordinates[1],
        lng: feature.geometry.coordinates[0]
      };
      if (this.widget.map.getBounds().contains(new google.maps.LatLng(coordinate))) {
        featuresInBoundingBox.push(feature);
      }
    });
    deferred.resolve(featuresInBoundingBox);
    return deferred.promise();
  }
}

export default BoundingBoxFilter;



// WEBPACK FOOTER //
// ./lmm-widget/src/filters/BoundingBoxFilter.js